// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__OTndG","bottomContainer":"styles_bottomContainer__OKMsd","sendLinkBtn":"styles_sendLinkBtn__zjpPX","loadingBtn":"styles_loadingBtn__3pPYS"};